// extracted by mini-css-extract-plugin
export default {"item":"preloader_item__rkiWX"};